import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "./cn";
const badgeVariants = cva("inline-flex w-fit shrink-0 items-center justify-center gap-1 rounded-md border px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-colors", {
    variants: {
        variant: {
            default: "border-transparent bg-primary text-primary-foreground",
            secondary: "border-transparent bg-secondary text-secondary-foreground",
            outline: "border-border text-foreground",
            destructive: "border-transparent bg-destructive text-white",
            success: "border-transparent bg-emerald-100 text-emerald-800",
            warning: "border-transparent bg-amber-100 text-amber-800",
        },
    },
    defaultVariants: { variant: "secondary" },
});
export function Badge({ className, variant, ...props }) {
    return (_jsx("span", { "data-slot": "badge", className: cn(badgeVariants({ variant }), className), ...props }));
}
export { badgeVariants };
//# sourceMappingURL=badge.js.map